import { render, staticRenderFns } from "./supplierPayableAmountRecord.vue?vue&type=template&id=fda8837e&scoped=true"
import script from "./supplierPayableAmountRecord.vue?vue&type=script&lang=js"
export * from "./supplierPayableAmountRecord.vue?vue&type=script&lang=js"
import style0 from "./supplierPayableAmountRecord.vue?vue&type=style&index=0&id=fda8837e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda8837e",
  null
  
)

export default component.exports